const glyphs = [
    "polyA",
    "polypeptide-region",
    "primer-binding-site",
    "process",
    "promoter",
    "protease-site",
    "protein",
    "protein-stability-element",
    "replacement-glyph",
    "ribonuclease-site",
    "ribosome-entry-site",
    "rna-stability-element",
    "signature",
    "simple-chemical-circle",
    "simple-chemical-hexagon",
    "simple-chemical-pentagon",
    "simple-chemical-triangle",
    "specific-recombination-site",
    "ssNA",
    "stimulation",
    "terminator",
    "three-prime-overhang",
    "three-prime-sticky-restriction-site",
    "transcription-end",
    "translation-end",
    "unspecified-glyph",
    "aptamer",
    "assembly-scar",
    "association",
    "blunt-restriction-site",
    "cds",
    "cds-arrow",
    "chromosomal-locus",
    "circular-plasmid",
    "complex-sbgn",
    "composite",
    "control",
    "degradation",
    "dissociation",
    "dna-stability-element",
    "dsNA",
    "engineered-region",
    "five-prime-overhang",
    "five-prime-sticky-restriction-site",
    "generic-sbgn",
    "halfround-rectangle",
    "inert-dna-spacer",
    "inhibition",
    "insulator",
    "intron",
    "location-dna",
    "location-dna-no-top",
    "location-protein",
    "location-protein-no-top",
    "location-rna",
    "location-rna-no-top",
    "macromolecule",
    "na-sbgn",
    "ncrna",
    "no-glyph-assigned",
    "nuclease-site",
    "omitted-detail",
    "operator",
    "origin-of-replication",
    "origin-of-transfer"
]

export default glyphs;